import React, { PropTypes } from 'react';
import { FormattedDate } from 'react-intl';
// Components
import Table from '../../layout/sui/table/Table';
import Head from '../../layout/sui/table/head/Head';
import Body from '../../layout/sui/table/body/Body';
import Event from './Event';


const propTypes = {
  activeDay: PropTypes.number.isRequired,
  schedule: PropTypes.array,
};

const GeneralProgrammingTable = (props) => {
  const schedule = props.schedule.map((event) => {
    return (
      <Event
        key={event.title}
        activeDay={props.activeDay}
        title={event.title}
        start={event.start}
        end={event.end}
      />
    );
  });

  return (
    <Table extraClasses="bottom attached">
      <Head>
        <tr>
          <th colSpan="2">
            <FormattedDate
              value={new Date(`October ${props.activeDay}, 2016`)}
              month="long"
              day="2-digit"
            />
          </th>
        </tr>
      </Head>
      <Body>
        { schedule }
      </Body>
    </Table>
  );
};

GeneralProgrammingTable.propTypes = propTypes;

export default GeneralProgrammingTable;



/** WEBPACK FOOTER **
 ** ./src/components/screens/generalProgramming/GeneralProgrammingTable.js
 **/